import React from 'react';
import { Col, Row } from 'react-bootstrap';

const Manual = ({ data }: any) => {
  return (
    <div className="Manual-Background">
      <div className="container">
        <Row md={4} xs={1}>
          {data.Buttons.map((item: any, i: number) => {
            return (
              <Col key={i}>
                <div className="Manual-flex">
                  <h4 className="Manual-h4">{item.label}</h4>
                  <div>
                    <a href={item.buttonLink} className="Manual-button" target="_blank" rel="noreferrer">
                      <span>{item.buttonLabel}</span>
                    </a>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </div>
  );
};

export default Manual;
